import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/50 via-background-50 to-accent-100/40"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-flashlight-line text-sm"></i>
              <span className="whitespace-nowrap">高清流畅 · 不缓冲秒播</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              屁屁影院
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-2">
                电视剧全集免费在线观看
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading font-semibold mb-5">
              最新热播同步追，剧集完整一站享用
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              屁屁影院汇集海量电视剧、电影、动漫、综艺等影视资源，每日同步更新最新热播剧集。
              高清画质流畅播放不卡顿，全集完整一追到底。无论热门国产剧、经典港剧、高分韩剧还是
              欧美大片，都能在这里免费在线观看，打造属于你的专属追剧空间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">20000+</strong> 部影视资源
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-timer-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">每日</strong> 同步更新
                </span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-700">
                  <strong className="text-foreground-950">高清</strong> 流畅秒播
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleClick(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-100 text-foreground-800 rounded-lg font-medium text-sm hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap border border-background-200/70"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                查看热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-200/30 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20cozy%20home%20theater%20setup%2C%20a%20large%20display%20screen%20showing%20soft%20ambient%20light%2C%20comfortable%20viewing%20environment%20with%20warm%20lighting%2C%20modern%20minimal%20interior%2C%20golden%20and%20amber%20tones%2C%20artistic%20abstract%20composition%2C%20cinematic%20atmosphere%20with%20soft%20shadows%2C%20high%20quality%20photography%20style&width=700&height=560&seq=hero-visual-pipi-01&orientation=landscape"
                alt="屁屁影院高清流畅追剧体验"
                className="relative w-full rounded-2xl object-cover"
                style={{ aspectRatio: '5/4' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}